var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackUpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.349,
    height: 18.729,
    viewBox: "0 0 16.349 18.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11460",
    "data-name": "Group 11460",
    transform: "translate(-341.954 -488.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_634",
    "data-name": "Rectangle 634",
    d: "M1.454.145A1.31,1.31,0,0,0,.145,1.454V15.7A1.31,1.31,0,0,0,1.454,17.01h3.2A1.31,1.31,0,0,0,5.961,15.7V1.454A1.31,1.31,0,0,0,4.652.145h-3.2m0-.145h3.2A1.454,1.454,0,0,1,6.106,1.454V15.7a1.454,1.454,0,0,1-1.454,1.454h-3.2A1.454,1.454,0,0,1,0,15.7V1.454A1.454,1.454,0,0,1,1.454,0Z",
    transform: "translate(342.204 489.422)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_638",
    "data-name": "Rectangle 638",
    d: "M1.454.145A1.31,1.31,0,0,0,.145,1.454V15.7A1.31,1.31,0,0,0,1.454,17.01h3.2A1.31,1.31,0,0,0,5.961,15.7V1.454A1.31,1.31,0,0,0,4.652.145h-3.2m0-.145h3.2A1.454,1.454,0,0,1,6.106,1.454V15.7a1.454,1.454,0,0,1-1.454,1.454h-3.2A1.454,1.454,0,0,1,0,15.7V1.454A1.454,1.454,0,0,1,1.454,0Z",
    transform: "matrix(0.97, -0.242, 0.242, 0.97, 347.925, 490.416)",
    fill: "none",
    stroke: "#29a19c",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackUpIcon);
export default __webpack_public_path__ + "static/media/BackUpIcon.cfe1677c5ea860c390bc1ea107b962ce.svg";
export { ForwardRef as ReactComponent };